import { Component, OnInit, ViewChild,  Input } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '../../components/base-component/base.component';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { Status } from '../../enums/shared-enums.enum';
import { ReceiverType } from '../../enums/shared-enums.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { LayoutService } from '../../../../layout/services/layout.service';
import { RoutesConstants, RolesConstants, ConfigConstant } from '@shared/constants';
import { RoutesUtil } from '../../utils/routes.util';
import { ReceiverAPI } from '@features/receivers/services/receiver-api.service';
import { UserApi } from '../../services/user-api.service';
import { Receiver } from '@features/receivers/models/receiver.model';

@Component({
  selector: 'app-receivers-list',
  templateUrl: './receivers-list.component.html',
  styleUrls: ['./receivers-list.component.scss'],
})
export class ReceiversListComponent extends BaseComponent implements OnInit {
  receiverType: ReceiverType.Customer;
  rolesConstants = RolesConstants;
  public dataSource: MatTableDataSource<Receiver>;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Input() fullPage: boolean = true;

  public displayedColumns: string[] = [
    'name',
    'contactName',
    'mobileNumber',
    'address',
    'action'
  ];

  status = Status;
  sharedConstants = RoutesConstants;

  originalReceivers: Receiver[] = [];

  //pagination
  pageSize: number = ConfigConstant.PAGE_SIZE;
  pageIndex: number = 1;
  offset: number = ConfigConstant.INIT_PAGE_OFFSET;
  totalRowsCount: number;
  RoutesUtil = RoutesUtil;

  constructor(
    public layoutService: LayoutService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private receiverAPI: ReceiverAPI,
    private userApi: UserApi
  ) {
    super();
  }
  ngOnInit(): void {
    const { id } = this.activatedRoute.snapshot.params;
    this.getReceivers(+id);
  }

  getReceivers(id: number) {
    this.load(this.receiverAPI.getAllReceivers(id).pipe(takeUntil(this.destroy$)), {
      isLoadingTransparent: true,
      emptyContentCheck: (res) => !res?.length,
    }).subscribe(
      (receivers) => {
        this.setupTable(receivers);
      }
    );
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
  }

  onPageIndexChange(index: number) {
    this.pageIndex = index;
    this.offset = (this.pageIndex - 1) * this.pageSize;
    this.dataSource.data = this.getCurrentReceivers(this.offset, this.pageSize * this.pageIndex);
  }


  onPageSizeChange(size:number){
    this.pageSize = size;
    this.dataSource.data = this.getCurrentReceivers(this.offset, this.pageSize * this.pageIndex);
  }

  getCurrentReceivers(fromIndex: number, toIndex: number): Receiver[] {
    return this.originalReceivers.slice(fromIndex, toIndex);
  }

  navigateToDetailsPage(receiverId: number) {
    this.router.navigate([RoutesUtil.ReceiversView.url({ receiverId })]);
  }
  private setupTable(receivers: Receiver[]) {
    this.originalReceivers = receivers;
    this.dataSource = new MatTableDataSource<Receiver>(this.getCurrentReceivers(0, this.pageSize));
    this.totalRowsCount = receivers.length;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (receivers, tableSortableProperty) => {
      switch (tableSortableProperty) {
        case 'contactName':
          return receivers.contactPerson[0]?.fullName().toLowerCase();
        case 'mobileNumber':
          return receivers.contactPerson[0]?.mobileNumber.toLowerCase();
        case 'address':
          return receivers.locations[0]?.address.toLocaleLowerCase();
      }
    };
  }

  onExportClicked() {
    this.load(this.receiverAPI.exportRecivers(this.userApi.currentUser$.value.parentId)).subscribe((res) => {
      window.open(res.fileUri, '_blank');
      this.showSuccessMessage('SuccessMessages.FileExportedSuccessfully');
    });
  }
}
